'use client';

import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

import { toastBase } from '@/fo/ui/kit/toast/base';

export function EmailChangedToast() {
  const t = useTranslations();

  useEffect(() => {
    if (!document.cookie.includes('email_changed=')) return;

    document.cookie = 'email_changed=; path=/; max-age=0';
    toastBase(t('form.message.success'));
  }, [t]);

  return null;
}
